var _path, _path2, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxOpenLongTime({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66634 9.99935C1.66634 14.6017 5.3973 18.3327 9.99967 18.3327C14.602 18.3327 18.333 14.6017 18.333 9.99935C18.333 5.39698 14.602 1.66602 9.99967 1.66602",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5V10.8333H13.3333",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0003,
    cy: 9.99935,
    r: 8.33333,
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "0.5 3.5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4056_19593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxOpenLongTime);
export default __webpack_public_path__ + "static/media/BoxOpenLongTime.0f204e45dabf6b6534650a8dccaa3677.svg";
export { ForwardRef as ReactComponent };